module.exports = __webpack_public_path__ + "static/media/fa-brands-400.7559b377.woff2";